/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("FaqAccordion", ["jquery", "Behaviors"], factory);
    } else {
        root.FaqAccordion = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function FaqAccordion() {
        Behaviors.init(FaqAccordion, this, arguments);

        var accordionItemHeading = this.$elem.find(FaqAccordion.ELEMENTS.accordionItem);
        var activeinitialHeading = jQuery('.FaqAccordion-content_details_accordion_content_items .FaqAccordion-content_details_accordion_content_items_item:nth-child(1) .FaqAccordion-content_details_accordion_content_items_item_title');
        var activeinitialContent = jQuery('.FaqAccordion-content_details_accordion_content_items .FaqAccordion-content_details_accordion_content_items_item:nth-child(1) .FaqAccordion-content_details_accordion_content_items_item_content');

        activeinitialHeading.addClass('FaqAccordion-content_details_accordion_content_items_item_title--open');
        activeinitialContent.slideDown();
        accordionItemHeading.on('click', function(e) {
            e.preventDefault();
            if(jQuery(this).hasClass('FaqAccordion-content_details_accordion_content_items_item_title--open')) {
                jQuery(this).siblings('.FaqAccordion-content_details_accordion_content_items_item_content').slideUp();
                jQuery(this).removeClass('FaqAccordion-content_details_accordion_content_items_item_title--open');
            }
            else {
                jQuery('.FaqAccordion-content_details_accordion_content_items_item_content').slideUp();
                accordionItemHeading.removeClass('FaqAccordion-content_details_accordion_content_items_item_title--open');
                jQuery(this).siblings('.FaqAccordion-content_details_accordion_content_items_item_content').slideToggle();
                jQuery(this).toggleClass('FaqAccordion-content_details_accordion_content_items_item_title--open');
            }
        });
    }

    Behaviors.inherit(FaqAccordion, Behaviors.Behavior);

    FaqAccordion.QUERY = "[data-FaqAccordion-accordion]";
    FaqAccordion.ELEMENTS = {
        accordionItem: ".FaqAccordion-content_details_accordion_content_items_item_title"
    };
    
    Behaviors.register_behavior(FaqAccordion);
    
    module.FaqAccordion = FaqAccordion;
    
    return module;
}));
